module.exports = {"450722001":"小江街道","450722002":"江城街道","450722101":"泉水镇","450722102":"石埇镇","450722103":"安石镇","450722104":"张黄镇","450722105":"大成镇","450722106":"白石水镇","450722107":"北通镇","450722108":"三合镇","450722109":"龙门镇","450722110":"福旺镇","450722111":"寨圩镇","450722112":"乐民镇","450722113":"六硍镇","450722114":"平睦镇","450722115":"官垌镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450722.json
// module id = 2255
// module chunks = 0